import { Injectable } from "@angular/core";
import { IID_UNLOCK_CODE } from "@common/interfaces/interfaceData";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { InterfaceDataQuery } from "../interfaceDataRegistry";
import { IIDUnlockCodeStore } from "./iidUnlockCode.store";

@Injectable({ providedIn: 'root' })
@InterfaceDataQuery(InterfaceName.UNLOCK_CODE)
export class IIDUnlockCodeQuery extends AbstractInterfaceDataQuery<IID_UNLOCK_CODE> {
  constructor(protected store: IIDUnlockCodeStore) { super(store); }
}
